import { useTranslation } from 'react-i18next';
import type { ProblemDetails } from '#pie/internal/api/pie-bff';

interface Props {
  error: unknown;
  className?: string | undefined;
}

export const ErrorMessageBlock = ({ error, className }: Props) => {
  const { t } = useTranslation();

  const problemDetails = error as ProblemDetails;
  return (
    <div className={`${className} flex flex-col gap-1`}>
      <div>{t('common.error_loading_data')}</div>
      <div className="text-sm text-content-secondary">
        {t('common.error_date')} {new Date().toISOString()}
      </div>
      {problemDetails?.traceId && (
        <div className="text-sm text-content-info">
          TraceId: {problemDetails.traceId}
        </div>
      )}
    </div>
  );
};
